var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12 px-1" }, [
        _c("div", { staticClass: "bg-gray2 py-2" }, [
          _c(
            "button",
            {
              staticClass: "ob1-link-arrow",
              attrs: {
                id: "legalMentions-header",
                type: "button",
                "data-bs-toggle": "collapse",
                "data-bs-target": "#legalMentions-text",
                "aria-controls": "legalMentions-text",
                "aria-expanded": "false",
              },
            },
            [
              _vm._v(
                "\n                    " +
                  _vm._s(_vm.legalMentions.title) +
                  "\n                "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "collapse",
              attrs: {
                id: "legalMentions-text",
                role: "region",
                "aria-labelledby": "legalMentions-header",
              },
            },
            [
              _c("p", { staticClass: "d-flex flex-column" }, [
                _c("span", {
                  domProps: { innerHTML: _vm._s(_vm.legalMentions.text.first) },
                }),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(_vm.legalMentions.text.second),
                  },
                }),
              ]),
            ]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }